module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter Two")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("‘Everything okay with you?’ Jesse asked, refilling my glass.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sure,’ I said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Kids doing okay?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘They’re teenagers. Their lives revolve around themselves and their friends. They’re not happy with the separation and Garth’s new girlfriend, but they’re handling it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It can’t be easy.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, but there’s no alternative.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jesse glanced at Carly, who was flirting up a storm with her new friends. ‘Should we do something about her?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She’s a big girl. Give her ten minutes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jesse nodded. ‘Sometimes I envy you. You’re free. Have no one to answer to.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Except my kids.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s different. They won’t always be living with you. You can have your own headspace. You can please yourself, not always be worrying about what your husband thinks.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How’s it going with Steve?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Same old, same old. He can’t get enough sex, but he doesn’t care about me enough to introduce me to his new colleagues. I had to beg him to take me to the company Christmas party. A couple of times when I joined in the conversation, he frowned, as if I was about to say something wildly inappropriate.’ She sighed and looked up from her glass. ‘And you know what, Stella? I never do. I keep it all hidden.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I wanted to tell her to wake up to herself and dump her dickhead husband. But I’d told her that a few times already. I wasn’t going to spoil this conversation by suggesting it again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m just being dramatic.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I wasn’t so sure. And what did she mean about keeping things hidden? From what Jesse had told me, Steve spent a lot of time working late and hardly noticed her when he was around, except when he was after a blow job. He hadn’t always been so dismissive of her. When I’d met him several years earlier, he’d been open, accommodating and much kinder to Jesse. These days, I hardly ever saw him. Before Garth and I split, we’d occasionally had them over for a barbeque, but Steve usually ended up drifting away from the conversation towards whatever the kids were watching on television, or else he’d sit there raising an eyebrow if he didn’t agree with what was being said, leaving the impression he thought he was superior to us, that we should be honoured he’d deigned to be in our company.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And,’ Jesse said, ‘I really want another baby.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I took her hand. ‘You any closer?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She sipped her wine, then shook her head. ‘I don’t blame Steve. I know he’s busy, tired and fed up. He doesn’t want to add to the pressure by having another mouth to feed.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You can afford it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Emotionally, Stella. Steve says he doesn’t have the energy or time to devote to raising another child. Although he’s also said it would be “fiscally irresponsible to bring another child into this unpredictable world”.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re talking about a baby, not a new car.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She shrugged, and we both looked at the empty bottle on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Should I buy another one?’ she asked, just as Carly bounced back.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve met the most amazing guys,’ she told us. ‘Mike’s a dad from school, and the others work with him. We’re all heading to a party later. Want to come?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I glanced at Mike who was looking sheepish.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I don’t think it’s a good idea,’ I said, recalling the disastrous coffee date.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But they’re doctors.’ She noted the empty bottle. ‘Who’s for more wine?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m in,’ I said distractedly. ‘They don’t look like axe murderers, but you never know.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jesse nodded. ‘Looks can be deceptive.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Please!’ Carly snorted, and headed towards the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Stella, has Liz mentioned anything more about the full-time position coming up? I wanted to talk to her today, but she was sighing and shaking her head a lot so thought it best to avoid her.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Wise.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jesse is a librarian as well. That’s how we met ten years ago, working together at the library, cataloguing nonfiction. Liz is our newish boss (six months) and has a few issues with Jesse.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Not really.’ I let the words hang.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thankfully, Jesse’s mobile rang. She took it from her bag and walked outside.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("When I told people my profession, they immediately gave me a sly – or in many cases, not-so-sly – once-over, then said, ‘You don’t look like a librarian.’ As if it were a compliment.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Really,’ I’d say. ‘And what are we supposed to look like?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They’d throw me a few stereotypes from the 1950s and my eyes would glaze over. No, I didn’t wear thick horn-rimmed glasses. I’d never worn my hair in a bun, nor was I mean or a spinster. I did wear cardigans though.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carly returned with a new bottle of wine and poured a couple of glasses. ‘Want to join them?’ she asked, looking over at Mike and his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shook my head, scratching imaginary itches on my arms. ‘You go. I’ll wait for Jesse.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Whatever.’ And Carly was off, back to flirting with Mike’s friend.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He had messy dark curly hair that sat just below his collar, a three-day growth, and was tanned and tall, just like her. Mike was probably a bit older than we were, but the other two looked young, well under thirty. I felt a bit rude not going over to say hello – I had asked Mike here, after all. But I was still scratching myself. It was better to say nothing than to start a conversation and say something stupid.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hey,’ Jesse said, returning to our table, ‘Steve’s just rung. He’s been held up at work. I told the babysitter someone would be home by ten, so it looks like I’m done for the night.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But this is "), _c('i', [_vm._v("our")]), _vm._v(" night, Jess,’ I said, wounded. ‘We’ve been planning this for months. Can’t you ring the babysitter?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Truthfully, it’s not worth it. Besides, I’m tired.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A squeal drew our attention to Carly, who was standing with Mike and his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sorry to dump her on you,’ Jesse said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Don’t worry. I’ll see she gets home in one piece.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jesse pushed her way through the crowd towards the exit. Carly was sitting on the doctor’s lap.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mike smiled at me, stood, beer in hand, and came over. ‘This seat taken?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I stammered something unintelligible. Where was my brain?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s clear you weren’t going to join me.’ He sat down. ‘So, do you want to talk about the coffee date?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I blushed. ‘It wasn’t a date, and no, not really.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pity. I thought it went well, until you stopped returning my text messages.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I sent you messages.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘"), _c('i', [_vm._v("Thanks")]), _vm._v(" and "), _c('i', [_vm._v("Nice to see you again")]), _vm._v(" weren’t the kind of messages I had in mind.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Look, I’m no good at this. I’m…’ My cheeks were on fire.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re what? Gorgeous? Interesting? Have a great smile?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Stop. I’m too old for games. Besides, you’re only saying those things to get me into bed.’ Shit! Did I just say that out loud?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mike smiled. ‘I’m not.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Great! Not only had I said something wildly inappropriate, but he didn’t even fancy me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Not that the thought of kissing you hasn’t crossed my mind, but I’m not trying to rush you.’ He drained the last of his beer. ‘Not right now, anyway.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I beamed, pretty sure I was a bright shade of beetroot.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Stella, Stella, the night is young. Toby’s taking me to a party.’ Carly was swaying about ten centimetres from my head.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Standing to steady her, I said, ‘You don’t even know the guy. Let’s go home.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes, I do. He’s Toby and he’s a doctor. He feeds monkeys at the zoo in his spare time.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I looked at Mike, who was conveniently preoccupied reading a crumpled docket from inside his wallet.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Right,’ I said to Carly. ‘Toby sounds like fun, and if you feel the same way about him tomorrow, you two should meet up. But,’ I whispered, ‘you have a husband and child waiting for you at home.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She slumped into a chair. ‘Piffle. You’re such a party pooper.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At that moment, Toby appeared. ‘No pressure, but we’re taking off.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hold your horses,’ Carly squealed, standing again. She looked at Mike and me. ‘You coming?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I couldn’t let her go to the party by herself, so I tailed her outside. Mike followed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘There’s really no need,’ I said to him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s cool. Besides, you could probably use an extra hand.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He was right. I needed to stay with Carly, but I hadn’t driven, and I couldn’t fit into the car she was about to climb into, a black Lexus hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mike leaned over to Toby. ‘We’ll follow you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Toby nodded and told him an address. Carly got in beside him, which completely foiled my plan, because I’d been hoping to get her into Mike’s car and then ask him to drive us straight home. Then I’d planned on ditching Mike too – I needed some distance from him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Carly,’ I hissed. ‘You don’t know these people.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sure I do,’ she slurred. ‘They’re from some hospital.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She closed the door and Toby pulled away from the kerb. Bloody hell! This wasn’t the scenario I’d imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Within seconds, I was in the passenger seat of Mike’s SUV, following Toby up the Pacific Highway. At least we were heading in the direction of home.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d872b26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 81
// module chunks = 0